

/**
 * 
 * @param min 
 * @param max 
 * @param lineCount 
 * @returns 
 */
export const GetMemoryScaleByNumber = (min:number ,max:number ,lineCount:number ) : number[] =>
{
  var ans : number[] = [];
    var xaxisAvarage = Math.floor((max-min)/lineCount);
    ans.push(min);

    for(let  i = 0 ; i < lineCount; i++){
      ans.push(min+(xaxisAvarage* i));
    }
    ans.push(max);
    // console.debug(['GetMemoryScaleByNumber',ans]);
    return ans;
};